
var dropzone_upload = {
    init: function(documentsList, options) {
        if (documentsList.find("[data-dropzone]").length === 0) {
            debugger;
            return;
        }
        options.autoProcessQueue = (options.autoProcessQueue !== undefined ? options.autoProcessQueue : true);
        options.uploadMultiple = (options.uploadMultiple !== undefined ? options.uploadMultiple : false);
        // ($(".documents .card-body")[0]).addEventListener('drop', e => {
        //     console.log(e.dataTransfer.files[0]);
        //     e.preventDefault();
        //     uploadDropzone.drop(e);
        // }, false);
        // ($(".documents .card-body")[0]).addEventListener('dragover', e => {
        //     console.log(e.dataTransfer.files);
        //     e.preventDefault();
        // }, false);
        // $("[data-repositoryid].documents").on('drop', e => {
        //     console.log(e);
        //     uploadDropzone.drop(e.originalEvent);
        // });
        var uploadDropzone = new Dropzone(options.selector || "[data-dropzone]", {
            url: options.url || '/Document/Upload',
            maxFilesize: 50000,
            autoProcessQueue: options.autoProcessQueue,
            uploadMultiple: options.uploadMultiple,
            dictDefaultMessage: 'Dateien hochladen',
            createImageThumbnails: false,
            clickable: (options.clickable ? $(options.clickable).get() : documentsList.find('[data-dz-upload]').get()),
            // acceptedFiles: '.csv,.xlsx,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            paramName: "File",
            previewTemplate: '<div class="modal dz-preview dz-file-preview" role="dialog">' +
                '  <div class="modal-dialog dz-details">' +
                '    <div class="modal-content">' +
                '      <div class="modal-header">' +
                '        <strong class="modal-title"><div class="dz-filename"><span data-dz-name></span><span class="dz-size" data-dz-size></span></div></strong>' +
                '      </div>' +
                '      <div class="modal-body">' +
                '        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
                '        <div class="dz-error-message"><span data-dz-errormessage></span></div>' +
                '      </div>' +
                '      <div class="modal-footer" style="display:none;">' +
                '      </div>' +
                '    </div>' +
                '  </div>' +
                '</div>',
            sending: function(file, xhr, formData) {
                documentsList.startProcess();
                if (options.onSending) options.onSending(file, xhr, formData);
                formData.append("repositoryId", documentsList.attr('data-repositoryId'));
                formData.append("parentId", documentsList.attr('data-parentid'));
            },
            addedfile: function (file) {
                if (options.autoProcessQueue) {
                    var uploadPreview = '<div data-upload="' + file.name + '">' +
                        '  <div class="progress">' +
                        '    <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>' +
                        '  </div>' +
                        '  <span class="message">' + file.name + '</span>' +
                        '</div>';

                    toastr.info(uploadPreview, 'Upload ...', {
                        closeButton: true,
                        newestOnTop: false,
                        timeOut: 0,
                        extendedTimeOut: 0
                    });
                    var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                    uploadToast.find('.toast-close-button').hide().prop('disabled', 'disabled');
                } else {
                    if (options.onFileAdded) options.onFileAdded(file);
                }
            },
            uploadprogress: function (file, bytesSent) {
                $('#toast-container [data-upload="' + file.name + '"] .progress-bar').width(bytesSent + '%');
            },
            complete: function (file, message) {
                if (file.accepted) {
                    uploadDropzone.removeFile(file);
                }
                documentsList.endProcess();
            },
            canceled: function (file, message) {
                uploadDropzone.removeFile(file);
            },
            error: function(file, data) {
                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.removeClass('toast-info').addClass('toast-error');
                uploadToast.find('.toast-close-button').show().prop('disabled', null);
                uploadToast.find('.toast-title').html('Fehler');
                uploadToast.find('.message').append('<br/>' + data.error);
            },
            success: function (file, responseText) {
                var file = responseText.file;
                documentsList.trigger('file-added', { file: file, response: responseText });

                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.removeClass('toast-info').addClass('toast-success');
                uploadToast.find('.toast-close-button').show().prop('disabled', null);

                setTimeout(function () {
                    uploadToast.remove();
                }, 500);
                if (options.onSuccess) options.onSuccess(file, responseText);
            },
            queuecomplete: function() {
                documents.loadFolder(documentsList.attr('data-parentid'));
                if (options.onQueuecomplete) options.onQueuecomplete();
            }
        });
        $(options.selector || "[data-dropzone]").data('dz', uploadDropzone);
    }
}

window.dropzone_upload = dropzone_upload;

var documents = {
    container: null,
    folderNameEls: null,
    docList: null,
    repositoryId: null,
    newFolderForm: null,

    init: function(container, options) {
        options = options || {};
        documents.container = container;
        documents.repositoryId = container.attr('data-repositoryId');
        documents.folderNameEls = container.find('.folder-name');
        documents.newFolderForm = options.newFolderForm || container.find('.newfolder');
        documents.docList = container.find('#docs-' + documents.repositoryId);
        documents.loadFolder('');
        documents.newFolderForm.find('[data-save]').off('click').click(function (ev) {
            var controlEl = documents.newFolderForm.find('input');
            documents.createFolder(controlEl, true);
        });
        $('body').click(documents.bodyClick);

        $(window).on("popstate", function(e) {
            if (e.originalEvent.state !== null) {
                console.log('load folder: ' + e.originalEvent.state.parentId);
                documents.loadFolder(e.originalEvent.state.parentId, true);
                return false;
            }
            history.back();
            return true;
        });
    },

    loadFolder: function(id, isPopstate) {
        if (!documents.docList) {
            return;
        }
        documents.docList.startProcess();
        var data = {
            parentId: id,
            repositoryId: documents.repositoryId,
        };
        if (documents.docList.is('[data-params]')) {
            var addData = JSON.parse(documents.docList.attr('data-params'));
            data = $.extend(data, addData);
        }
        connection.getJson('/Document/DocumentListOfFolder', {
            data: data,
            onComplete: function () {
                documents.docList.endProcess();
            },
            onSuccess: function (data) {
                documents.folderNameEls.html('');
                $('<span class="btn btn-card-header px-2 py-0" data-openfolder=""><i class="fa fa-home fa-fw"></i></span>').appendTo(documents.folderNameEls);
                $.each(data.tree, function (i, el) {
                    $('<i class="fa d-none fa-angle-right"></i><span class="btn btn-card-header px-2 py-0" data-openfolder="' + el.id + '">' +
                        '  <i class="fa fa-fw text-warning bi-folder-fill mr-1"></i> ' + el.name + '' +
                        '</span>').appendTo(documents.folderNameEls);
                });
                if (data.folderName !== "") {
                    $('<i class="fa d-none fa-angle-right"></i>' +
                        '<strong class="btn btn-card-header px-2 py-0">' +
                        '  <i class="fa fa-fw text-warning bi-folder2-open mr-1"></i>' + data.folderName + '' +
                        '</strong>').appendTo(documents.folderNameEls);
                }
                documents.folderNameEls.find('[data-openfolder]').click(function () {
                    documents.loadFolder($(this).attr('data-openfolder'));
                });
                if (!isPopstate) {
                    console.log('history add: ' + id);
                    history.pushState({"parentId": id}, null, null);
                }

                documents.container.attr('data-parentId', id);
                documents.docList.html($(data.content.trim()));
                documents.docList.find('.doc-row').click(documents.selectRow);
                documents.docList.find('[data-open]').on('dblclick', function () {
                    var me = $(this);
                    window.open(me.attr('data-open'));
                });
                documents.docList.find('[data-openfolder]').click(function () {
                    var me = $(this);
                    documents.loadFolder(me.attr('data-openfolder'));
                    return false;
                });
                initSlideinButtons(documents.docList.find('[data-slidein],[data-static-slidein]'));
                onContentReady(documents.docList.closest(".card-body"));
            }
        });
    },

    selectRow: function(ev, rowEl) {
        var row = rowEl || $(this);
        var container = row.closest('.documents');
        container.find('.doc-row.selected').removeClass('selected');
        row.addClass('selected');
    },

    unselectRow: function() {
        $('.doc-row.selected').removeClass('selected');
    },

    startRenameFile: function(fileEl) {
        var html = ('<div><form class="form" action="/Document/RenameFile" method="post">' +
            '<input type="hidden" name="id" value="' + fileEl.attr('data-id') + '" />' +
            '<div class="form-group">' +
            '<input class="form-control" type="text" name="name" value="' + fileEl.find('.name').text() + '" data-val="' + fileEl.find('.name').text() + '" />' +
            '<div class="invalid-feedback"></div>' +
            '</div>' +
            '</form></div>');
        var dialogEl = messaging.askContentDialog(fileEl, 'Datei umbenennen', html);

        var form = dialogEl.find('form');
        notification.addButton(dialogEl, {
            caption: "umbenennen",
            cssClass: "btn btn-success",
            callback: function() {
                form.submit();
                return false;
            }
        });
        form.on('submit', function() {
            connection.saveForm(form, function() {
                fileEl.find('.name').text(dialogEl.find('[name="name"]').val());
                notification.close(dialogEl);
            });
            return false;
        });
    },

    bodyClick: function(event) {
        if ($(event.target).parents('.documents').length === 0) {
            documents.unselectRow();
        }
    },

    createFolder: function(controlEl, validateEmpty) {
        validateEmpty = validateEmpty || false;
        if (controlEl.val().trim() === '') {
            if (validateEmpty) {
                messaging.showGlobalMessage('danger', null, 'Gebe einen Namen für den neuen Ordner ein.', 2000);
            } else {

            }
            return;
        }

        var parentId = documents.container.attr('data-parentId');
        connection.loadJson('/Document/CreateFolder?name='+controlEl.val().trim()+'&repositoryId='+documents.repositoryId+'&parentId='+parentId,
            null,
            function(data) {
                messaging.showGlobalMessage('success', null, 'Der Ordner wurde erstellt.', 2000);
                documents.loadFolder(data.parentId || '');
                controlEl.val('');
            }
        );
    },

    deleteFile: function(rowEl) {
        var row = rowEl || documents.container.find('.doc-row.selected');
        if (row.length === 0) {
            messaging.showGlobalMessage('warning', null, 'Keine Datei ist ausgewählt.', 2000);
        }

        if (row.attr('data-type') === "1") {
            messaging.askYesNo('Datei löschen', 'Willst du die Datei "'+row.attr('data-name')+'" wirklich löschen?', function() {
                connection.loadJson('/Document/Delete/'+row.attr('data-id'), null, function() {
                    row.remove();
                    messaging.showGlobalMessage('success', null, 'Die Datei wurde gelöscht.', 2000);
                });
            });
        } else {
            messaging.askYesNo('Ordner löschen', 'Willst du den Ordner "'+row.attr('data-name')+'" mit allen enthaltenen Dateien/Ordnern löschen?', function() {
                connection.loadJson('/Document/Delete/'+row.attr('data-id'), null, function() {
                    row.remove();
                    messaging.showGlobalMessage('success', null, 'Der Ordner wurde gelöscht.', 2000);
                });
            });
        }
    }

};

window.documents = documents;
